import { render, staticRenderFns } from "./SliderSingle.vue?vue&type=template&id=5f08da24&"
import script from "./SliderSingle.vue?vue&type=script&lang=js&"
export * from "./SliderSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports